// extracted by mini-css-extract-plugin
export default {"tooltip-label":"adc__tooltip-label--sycbj","tooltip-icon":"adc__tooltip-icon--e894F","lost-reserve-not-met-content":"adc__lost-reserve-not-met-content--Bryui"};